export const buttonLocaleDict = {
    ru: {
        save: 'Сохранить',
        cancel: 'Отмена',
        delete: 'Удалить',
        showGrid: 'Показать грид',
        showKanban: 'Показать канбан',
        showFiltersPanel: 'Показать панель фильтров',
        hideFiltersPanel: 'Скрыть панель фильтров',
        showPreviousComments: 'Показать предыдущие комментарии',
        hidePreviousComments: 'Скрыть предыдущие комментарии'
    },
    en: {
        save: 'Save',
        cancel: 'Cancel',
        delete: 'Delete',
        showGrid: 'Show grid',
        showKanban: 'Show kanban',
        showFiltersPanel: 'Show filters panel',
        hideFiltersPanel: 'Hide filters panel',
        showPreviousComments: 'Show previous comments',
        hidePreviousComments: 'Hide previous comments'
    },
    th: {
        save: 'บันทึก',
        cancel: 'ยกเลิก',
        delete: 'ลบ',
        showGrid: 'แสดงตาราง',
        showKanban: 'แสดงคัมบัง',
        showFiltersPanel: 'แสดงแผงตัวกรอง',
        hideFiltersPanel: 'ซ่อนแผงตัวกรอง',
        showPreviousComments: 'แสดงความคิดเห็นก่อนหน้า',
        hidePreviousComments: 'ซ่อนความคิดเห็นก่อนหน้า'
    },
    tr: {
        save: 'Kaydet',
        cancel: 'İptal',
        delete: 'Sil',
        showGrid: 'Tabloyu göster',
        showKanban: 'Kanbanı göster',
        showFiltersPanel: 'Filtre panelini göster',
        hideFiltersPanel: 'Filtre panelini gizle',
        showPreviousComments: 'Önceki yorumları göster',
        hidePreviousComments: 'Önceki yorumları gizle'
    }
};
